<mat-expansion-panel [class.mat-elevation-z0]="true" dense>
  <mat-expansion-panel-header> {{ menu.text }} </mat-expansion-panel-header>
  <mat-nav-list dense>
    <ng-container *ngFor="let m of menu.children">
      <a mat-list-item [routerLink]="m.routerLink"
        ><mat-icon>{{ m.icon }}</mat-icon
        >{{ m.text }}</a
      >
    </ng-container>
  </mat-nav-list>
</mat-expansion-panel>
